import classNames from 'classnames';

import { ClassNameType } from 'interfaces';

const styles = {
  component: (
    className: ClassNameType,
  ) => className,
  packagingButton: classNames(
    'flex',
    'justify-center',
    'items-center',
  ),
  toggleSection: classNames(
    'sm:flex',
    'justify-between',
    'content-center',
    '!mt-5',
  ),
  toggleButton1: classNames(
    '!mr-2',
    'lowercase',
  ),
  toggleButton2: classNames(
    'lowercase',
  ),
  packageType: classNames(
    'grid',
    'grid-cols-2',
    'gap-4',
  ),
  dimensionsInputsBlock: classNames(
    'grid',
    'grid-cols-2',
    'sm:grid-cols-3',
    'gap-x-8',
    'sm:gap-x-4',
    'gap-y-4',
  ),
  unitToggle: classNames(
    '!mt-0',
    '!mb-6',
    'sm:!my-5',
    'sm:flex',
    'justify-between',
  ),
};

export default styles;
